// Useful when mapping over a list to remove unwanted values
export function nullable<T>(t: T | undefined | null): t is T {
  return t !== undefined && t !== null;
}
